module.exports = __webpack_public_path__ + "static/media/IMG_1304.3f831164.jpg";